import React from 'react';
import { Button } from 'antd';

const Categories = () => {

return(
  <>
  <div className="container">
    <Button type="primary">Categories Page</Button>
  </div>
  </>
)
}

export default Categories;
